<template>
	<div>
		<el-button @click="filter.status = 0,getlist()" size="small">待审核</el-button>
		<el-button @click="filter.status = 1,getlist()" size="small">已完成</el-button>
		<el-button @click="filter.status = 2,getlist()" size="small">已驳回</el-button>
		<div class="first_line">
			<div class="right_warp">
				<el-select class="jul" size="small" filterable v-model="filter.storeId " style="margin-right:3px;"
					placeholder="请选择">
					<el-option v-for="item in statelist" :key="item.id" :label="item.label" :value="item.id">
					</el-option>
				</el-select>
				<el-date-picker value-format="yyyy-MM" size="small" v-model="filter.month" :clearable="false"
					type="month" placeholder="选择月">
				</el-date-picker>
				<el-button class="jul" type="primary" @click="getlist" size="small">筛选</el-button>
			</div>
			<div>
				<span size="small">门店数</span>
				<span size="big">{{this.todayUpdate}}/{{this.storeSum}}</span>
			</div>
		</div>
		<div>
			<div class="calendar">
				<el-table :data="list" style="width: 100%"
					:header-cell-style="{background:'#F2F2F4', 'text-align':'center'}"
					:cell-style="{'text-align':'center'}">
					<el-table-column prop="storeName" label="门店" />
					<el-table-column prop="createTime" label="提交日期"></el-table-column>
					<el-table-column prop="ename" label="提交者">
						<templete slot-scope="scope">
							{{scope.row.ename.split(' ')[0]}}
						</templete>
					</el-table-column>
					<el-table-column prop="estatus" label="状态">
						<templete slot-scope="scope">
							{{scope.row.estatus|typeFormat2}}
						</templete>
					</el-table-column>
					<el-table-column label="班表日期">
						<templete slot-scope="scope">
							{{scope.row.beginDate}}至{{scope.row.endDate}}
						</templete>
					</el-table-column>
					<el-table-column width="175">
						<template slot-scope="scope">
							<el-button type="text"
								@click="onPreview(scope.row.id,scope.row.disallowReason,scope.row.storeName,scope.row.estatus,scope.row.createTime)">查看
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div>
				<el-dialog :visible.sync="showViewer" width="30%" @close="closeViewer()">
					<h3>{{this.storeName}}</h3>
					<h3>{{this.status|typeFormat2}}-{{this.createTime}}</h3>
					<el-table :cell-style="{'text-align':'center'}"
						:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="Examinelist" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="date" label="排班日期"></el-table-column>
						<el-table-column prop="droster" label="班次">
							<templete slot-scope="{row}">
								{{ row.droster | typeFormat1}}
							</templete>
						</el-table-column>
						<el-table-column prop="name" label="发型师"></el-table-column>
					</el-table>
					<div>
						<h3>备注：</h3>
						<el-input size="small" v-model="filter1.reason" style="width: 500px; min-height:50px">
						</el-input>
						<el-button @click="edit(2) ">驳回</el-button>
						<el-button type="primary" @click="edit(1)">通过</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		parseTime,
		url
	} from "../../../utils/index.js"
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		components: {
			ElImageViewer
		},
		data() {
			return {
				url: url(),
				total: 0,
				list: [],
				dates: [],
				filter: {
					month: new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? '0' + (new Date()
						.getMonth() + 1) : (new Date().getMonth() + 1)),
					storeId: undefined,
					status: null,
				},
				filter1: {
					reason: ","
				},
				showViewer: false,
				times: "",
				timeVal: "",
				storeval: [],
				statelist: [{
					value: undefined,
					label: "全部门店"
				}],
				Examinelist: '',
				Examinelists: [],
				spanArr: [],
				tmpDate: '',
				tmpRow: [],
				reason: '',
				eid: '',
				storeSum: '',
				todayUpdate: 0,
				storeName: '',
				status: '',
				createTime: ''
			};
		},
		mounted() {
			this.getstorelist();
			this.getlist();
			this.TodayUpdate()
		},
		filters: {
			typeFormat1(val) {
				switch (val) {
					case "1":
						return "请假";
					case "-1":
						return "调休";
					default:
						return val;
				}
			},
			typeFormat2(val) {
				switch (val) {
					case "0":
						return "待审核";
					case "1":
						return "已完成";
					case "2":
						return "已驳回";
					default:
						return '';
				}
			},
		},
		methods: {
			getlist() {
				var arr = {
					status: this.filter.status,
					storeId: this.filter.storeId,
					month: this.filter.month
				}
				this.$http.get("dSchedulingExamine/findExamine", {
					params: arr
				}, {
					emulateJSON: true
				}).then((res) => {
					if (res.body.code == 200) {
						this.list = res.body.data
						this.total = res.body.total
					}
				})
			},
			getExamineList(id) {
				var a = {
					id: id
				}
				this.$http.get("dcheckuser/findExamineList", {
					params: a
				}, {
					emulateJSON: true
				}).then((res) => {
					if (res.body.code == 200) {
						this.Examinelist = res.body.data
						this.total = res.body.total
					}
					for (var i = 0; i < this.Examinelist.length; i++) {
						this.Examinelists[i] = this.Examinelist[i]
					}
				})
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					var i = 0;
					if (res.body.code == 200) {
						res.body.data.forEach(ele => {
							if (ele.businessType == 0) {
								this.storeSum = i++;
								this.statelist.push({
									id: ele.id,
									label: ele.title
								})
							}
						});
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			onPreview(id, reason, storeName, status, createTime) {
				this.storeName = storeName
				this.status = status
				this.createTime = createTime
				this.eid = id
				this.filter1.reason = reason
				this.getExamineList(id)
				this.showViewer = true
			},
			closeViewer() {
				this.showViewer = false
			},
			changeStyle(i) {
				if (i)
					return {
						active: true
					}
			},
			TodayUpdate() {
				this.$http.get("dSchedulingExamine/countUpdate").then((res) => {
					if (res.body.code == 200) {
						this.todayUpdate = res.body.data
					}
				})
			},
			edit(status, reason) {
				var b = {
					id: this.eid,
					status: status,
					disallowReason: this.filter1.reason
				}
				this.$http.post("dSchedulingExamine/updateExamine", JSON.stringify(b)).then(res => {
					if (res.body.code == 200) {
						this.getlist();
						this.$message.success(res.body.msg)
						this.showViewer = false;
					} else {
						this.$message.error(res.body.msg)
					}
				})
				this.TodayUpdate()
			},
		}
	}
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.active {
		color: red
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.pagechange {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>